import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import App from "./App.vue";
import router from "./router";
import store from "./store";
import '@/icons' // icon
import '@/permission' // permission control
import '@/static/styles/index.less' // global css
import {
  baseProtocolUrl
} from "@/utils/pageConf";
import {
  baseUrl
} from "@/utils/pageConf";

import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

import '@/assets/font/fonts.css'

Vue.use(ElementUI);

// 混入
import mixin from "@/mixin";
Vue.mixin(mixin);
// 过滤器
import * as filters from "@/utils/filters";
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]); //插入过滤器名和对应方法
});
//全局公共方法
import common from './util/js/common.js' //公共方法，加入vue的原型链
Vue.prototype.$common = common; /* 引入resize计算模块 */
Vue.config.productionTip = false;
Vue.prototype.$baseProtocolUrl = baseProtocolUrl // 可以直接在view层标签使用
Vue.prototype.$baseUrl = baseUrl // 可以直接在view层标签使用
import resize from "vue-element-resize-detector";
Vue.use(resize)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");